export default __webpack_public_path__ + "291c20043a2869b5755494b76b8a3e7e.otf";